import { TdsDivider } from '@scania/tegel-react'
import styled from 'styled-components'

export const StyledDivider = styled(TdsDivider)`
  @media (min-width: ${({ theme }) => theme.size.lg}) {
    display: none;
  }
`

export const CheckboxRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 16px;
  padding-bottom: 16px;

  > * {
    margin-right: 16px;
  }
`

export const Title = styled.h6.attrs({
  className: 'tds-headline-06'
})`
  margin-bottom: 0;
  margin-top: 16px;
`
